
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[id]",
      function () {
        return require("private-next-pages/p/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[id]"])
      });
    }
  